import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal } from 'features/common/components/Modal/Modal';
import { Icon as Trash } from 'features/common/components/Icon';
import { useResponsiveScreen } from 'hooks/useWindowSize';
import { QUATERNARY, TERTIARY } from 'features/common/components/Button/constants';

import {
	ContainerActionButtons,
	ContainerBody,
	ModalButton,
	Icon,
	Text,
	Button,
	DeleteButton,
} from './ModalDelete.styles';

const ModalDelete: FC = () => {
	const { t } = useTranslation();
	const isLargeScreen = useResponsiveScreen();
	const [showModal, setShowModal] = useState(false);

	const openModal = () => setShowModal(true);
	const closeModal = () => setShowModal(false);

	return showModal ? (
		<Modal onClose={closeModal}>
			<>
				<Modal.Header>{t('promoCode-modal-delete-title')}</Modal.Header>
				<Modal.Body>
					<ContainerBody>
						<Icon iconName="trashGrey" />
						<Text element="p">{t('promoCode-modal-delete-message')}</Text>
					</ContainerBody>
				</Modal.Body>
				<Modal.ActionButtons>
					<ContainerActionButtons>
						<ModalButton category={QUATERNARY} onClick={closeModal} text={t('button-cancel')} type="button" />
						<ModalButton category={TERTIARY} onClick={openModal} type="button" text={t('button-delete')} />
					</ContainerActionButtons>
				</Modal.ActionButtons>
			</>
		</Modal>
	) : isLargeScreen ? (
		<Button type="button" category={TERTIARY} onClick={openModal} text={t('promoCode-modal-delete-button')} />
	) : (
		<DeleteButton type="button" onClick={openModal}>
			<Trash iconName="trash" />
		</DeleteButton>
	);
};

export { ModalDelete };
